<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="kb-modal-title">
        <h3>{{ isEdit ? "Editar Pergunta" : "Nova Pergunta" }} da campanha</h3>
        <v-btn icon @click="close">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="kb-modal-body">
        <div class="kb-form">
          <div class="kb-field">
            <label>Pergunta *</label>
            <InputText
              type="text"
              place-holder="Escreva a pergunta"
              v-model="form.question"
              labelCharLimit="500"
              width="100%"
            />
          </div>

          <div class="kb-field">
            <label>Resposta *</label>
            <vue-editor
              v-model="form.answer"
              :editor-toolbar="customToolbar"
              placeholder="Escreva a resposta"
            />
          </div>

          <div class="kb-field-row">
            <div class="kb-field">
              <label>Categoria *</label>
              <v-select
                :items="categories"
                v-model="form._categoryId"
                item-text="name"
                item-value="id"
                placeholder="Selecione a categoria"
                hide-details
                @change="onCategoryChange"
              />
            </div>

            <div class="kb-field">
              <label>Subcategoria *</label>
              <v-select
                :items="subcategoryOptions"
                v-model="form.subcategoryId"
                item-text="name"
                item-value="id"
                :placeholder="form._categoryId ? 'Selecione a subcategoria' : 'Selecione a categoria primeiro'"
                :disabled="!form._categoryId"
                hide-details
              />
            </div>
          </div>

          <div class="kb-field">
            <v-checkbox
              v-model="form.isVisibleToDonor"
              label="Visível para o doador (caso contrário, somente IA acessa)"
              hide-details
            />
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="kb-modal-actions">
        <v-btn flat round @click="close">Cancelar</v-btn>
        <v-btn
          flat
          round
          color="white"
          class="btn-primary px-4"
          :disabled="!canSave"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script type="plain/text">
import CampaignService from "@/scripts/services/campaign.service";
import { VueEditor } from "vue2-editor";

const emptyForm = () => ({
  id: 0,
  campaignId: 0,
  question: "",
  answer: "",
  isVisibleToDonor: true,
  sortOrder: null,
  subcategoryId: null,
  _categoryId: null
});

export default {
  components: {
    VueEditor
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    dialog: false,
    isEdit: false,
    form: emptyForm(),
    campaignService: new CampaignService(),
    customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"]
    ]
  }),
  computed: {
    subcategoryOptions() {
      if (!this.form._categoryId) return [];
      const category = this.categories.find(c => c.id === this.form._categoryId);
      return category ? category.subcategories || [] : [];
    },
    canSave() {
      return (
        this.form.question &&
        this.form.question.trim().length > 0 &&
        this.form.answer &&
        this.form.answer.trim().length > 0 &&
        !!this.form.subcategoryId
      );
    }
  },
  methods: {
    // open(campaignId, faq?, { subcategoryId }?)
    open(campaignId, faq, options = {}) {
      this.form = emptyForm();
      this.form.campaignId = campaignId;

      if (faq) {
        this.isEdit = true;
        this.form.id = faq.id;
        this.form.question = faq.question;
        this.form.answer = faq.answer;
        this.form.isVisibleToDonor = faq.isVisibleToDonor !== false;
        this.form.sortOrder = faq.sortOrder != null ? faq.sortOrder : null;
        this.form.subcategoryId = faq.subcategoryId || null;
        this.form._categoryId = this.findCategoryIdBySubcategory(faq.subcategoryId);
      } else {
        this.isEdit = false;
        if (options.subcategoryId) {
          this.form.subcategoryId = options.subcategoryId;
          this.form._categoryId = this.findCategoryIdBySubcategory(options.subcategoryId);
        }
      }
      this.dialog = true;
    },
    findCategoryIdBySubcategory(subcategoryId) {
      if (!subcategoryId) return null;
      const category = this.categories.find(
        c => (c.subcategories || []).some(s => s.id === subcategoryId)
      );
      return category ? category.id : null;
    },
    onCategoryChange() {
      this.form.subcategoryId = null;
    },
    close() {
      this.dialog = false;
    },
    save() {
      const payload = {
        id: this.form.id,
        campaignId: this.form.campaignId,
        question: this.form.question,
        answer: this.form.answer,
        isVisibleToDonor: this.form.isVisibleToDonor,
        sortOrder: this.form.sortOrder,
        subcategoryId: this.form.subcategoryId
      };
      // SaveFaq do CampaignController recebe uma lista (upsert por id).
      this.campaignService.saveFaq(() => {
        this.$emit("saved");
        this.close();
      }, [payload]);
    }
  }
};
</script>

<style scoped>
.kb-modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.kb-modal-body {
  padding: 0 !important;
}
.kb-form {
  width: 100%;
  box-sizing: border-box;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kb-field {
  display: block;
  width: 100%;
  margin-bottom: 12px;
}
.kb-field-row {
  display: flex;
  gap: 16px;
}
.kb-field-row .kb-field {
  flex: 1;
  min-width: 0;
}
.kb-field > label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #555;
}
.kb-field /deep/ .input-comp,
.kb-field /deep/ input,
.kb-field /deep/ textarea {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
.kb-modal-actions {
  justify-content: flex-end;
  padding: 16px 24px;
}
</style>
